/**
 * Typed ops device health reconciliation API facade over the generated contract client.
 */

import { opsDeviceHealthReconciliationApi } from '../api/generated/opsDeviceHealthReconciliation.api.js';
import type { DeviceHealthReconciliationResponse } from '@cnapse/shared/schemas.js';

class OpsDeviceHealthReconciliationService {
  async getDeviceHealthReconciliation(): Promise<DeviceHealthReconciliationResponse> {
    return opsDeviceHealthReconciliationApi.getSummary() as Promise<DeviceHealthReconciliationResponse>;
  }
}

export const opsDeviceHealthReconciliationService = new OpsDeviceHealthReconciliationService();
